import "./Expeditions.module.css";
import Header from "@/reusable_sections/Header";
import CuratedExpeditionTiers from "./sections/CuratedExpeditionTiers";
import TravelerSMap from "./sections/TravelerSMap";
import Footer from "@/reusable_sections/Footer";
export default function ExpeditionsPage() {
  return <div>
      <Header />
      <CuratedExpeditionTiers />
      <TravelerSMap />
      <Footer />
    </div>;
}